import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { User } from '@core/account-types';
import { UserListTooltipComponent } from '@core/account-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { IconComponent, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-anonymous-revealed-for',
  template: `
    <div
      rtTooltip
      [rtTooltipTemplate]="tooltipTpl"
      [rtTooltipMaxWidth]="269"
      rtTooltipPosition="below"
      (click)="$event.stopImmediatePropagation()"
      layout
      layout-align-items-center
      padding-lr-small-x
      data-cy="anonymous-revealed-for"
    >
      <rt-icon name="info-outline" margin-right-small-xx />
      <span class="pointer-events-none" text-weight-semi-bold>
        {{
          'app.candidate.anonymization.team_members_revealed' | translate: { count: users().length }
        }}
      </span>
    </div>
    <ng-template #tooltipTpl>
      <rt-user-list-tooltip [users]="users()">
        <strong heading>
          {{ 'app.candidate.anonymization.who_seen_hidden_details' | translate }}
        </strong>
      </rt-user-list-tooltip>
    </ng-template>
  `,
  styleUrl: 'anonymous-revealed-for.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslatePipe, RtTooltip, UserListTooltipComponent],
})
export class AnonymousRevealedForComponent {
  public readonly users = input.required<User[]>();
}
